import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { FaArchive, FaBullhorn, FaBullseye, FaDollarSign, FaUserFriends, FaUsers } from "react-icons/fa";
import { Tab, TabList, Tabs } from "../../../components/core/basic/Tabs";
import { tagEntityTypeSchema, type TagEntityType } from "../../../zodios/apiDefinitions/api/tags";
import { HStack } from "../../../../styled-system/jsx";

// Pattern B: `label` is a selector resolved in the consumer's t scope so the
// option label is translated against the bound `tags` namespace at render.
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
type LabelSelector = ($: any) => any;

const ENTITY_TYPE_OPTIONS: { value: TagEntityType; label: LabelSelector; icon: ReactNode }[] = [
  { value: "ADVERTISEMENT", label: ($) => $.tags["Advertisements"], icon: <FaBullhorn /> },
  { value: "KEYWORD-TARGET", label: ($) => $.tags["Keywords"], icon: <FaBullseye /> },
  { value: "PRODUCT", label: ($) => $.tags["Products"], icon: <FaArchive /> },
  { value: "ORGANIZATION", label: ($) => $.tags["Organizations"], icon: <FaUsers /> },
  { value: "AUDIENCE", label: ($) => $.tags["Audiences"], icon: <FaUserFriends /> },
  { value: "PRICING_PLAN", label: ($) => $.tags["Pricing Plans"], icon: <FaDollarSign /> },
];

interface EntityTypeSidebarProps {
  value: TagEntityType;
  onChange: (value: TagEntityType) => void;
}

export function EntityTypeSidebar({ value, onChange }: EntityTypeSidebarProps) {
  const { t } = useTranslation(["tags"]);
  return (
    <Tabs
      variant="primary-nav"
      orientation="vertical"
      selectedKey={value}
      onSelectionChange={(key) => {
        const parsed = tagEntityTypeSchema.safeParse(key);
        if (parsed.success) {
          onChange(parsed.data);
        }
      }}
    >
      <TabList aria-label={t(($) => $.tags["Entity type"])}>
        {ENTITY_TYPE_OPTIONS.map((option) => (
          <Tab key={option.value} id={option.value}>
            <HStack gap="12px" alignItems="center">
              {option.icon}
              <span>{t(option.label)}</span>
            </HStack>
          </Tab>
        ))}
      </TabList>
    </Tabs>
  );
}
